import Logger from './utils/Logger';
import Room from './Room';
import { Event, RoomEvent, StreamEvent } from './Events';
import Stream from './Stream';
import ViewProperties from './views/ViewProperties';
import VideoPlayer from './views/VideoPlayer';
import VcxQuickApi from './VcxQuickApi';
import config from './../Common.config';
import clientHealth from './clientHealth';
// eslint-disable-next-line
require('expose-loader?adapter!../lib/adapter.js');
// eslint-disable-next-line
require('script-loader!./utils/L.Resizer.js');

const EnxRtc = {
  Logger,
  clientDiagnostics: clientHealth.clientDiagnostics,
  clientBitrate: clientHealth.clientBitrate,
  EnxRoom: Room.bind(null, undefined, undefined),
  Event,
  RoomEvent,
  StreamEvent,
  EnxStream: Stream.bind(null, undefined),
  VideoPlayer,
  ViewProperties,
  isSupported: config.is_supported,
  version: config.product.version,
  getDevices: VcxQuickApi.getDevice,
  switchMediaDevice: VcxQuickApi.switchMediaDevice,
  notifyDeviceUpdate: VcxQuickApi.notifyDeviceUpdate,
  joinRoom: VcxQuickApi.joinRoom,
  listParticipants: VcxQuickApi.listParticipants,
};
export default EnxRtc;



//////////////////
// WEBPACK FOOTER
// ./src/VcxRtc.js
// module id = 168
// module chunks = 0